import React, { useContext, useEffect, useState } from "react";
import { QUESTIONS } from "../../api/Api";
import { QuestionsPageContext } from "../../context/QuestionsPageContext";
import OrderBy from "./helper/OrderBy";
import throttle from "lodash.throttle";
import BreakPoints from "../../BreakPoints";
import SelectedQuestion from "../QuestionManagement/SelectedQuestion";
import QuestionsMap from "../QuestionManagement/QuestionsMap";
import { useInfiniteQuery } from "@tanstack/react-query";
import LoadingPage from "../../Pages/LoadingPage";
import { useIsSelectedQuestion } from "../../Store/QuestionSlice";
import { Axios } from "../../Axios/createAxios";

export default function QContent() {
  const { articleRef, order, period, selectedTag } = useContext(QuestionsPageContext);
  const { xLarge, xXLarge } = BreakPoints();
  const [stop, setStop] = useState(0);
  const isSelectedQuestion = useIsSelectedQuestion();
  const [eventTarget, setEventTarget] = useState({
    scrollContainer: null,
    element: null,
  });

  const fetchData = async ({ pageParam = null }) => {
    try {
      const res = await Axios.get(`/${QUESTIONS}`, {
        params: {
          cursor: pageParam,
          initial: !pageParam,
          order: order,
          period: period,
          tag: selectedTag,
        },
      });
      return res.data.details;
    } catch (e) {
      throw e;
    }
  };
  const { data, error, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage, status, isLoading } =
    useInfiniteQuery({
      queryKey: ["questions", order, period, selectedTag],
      queryFn: fetchData,
      staleTime: 1000 * 60 * 10,
      keepPreviousData: true,
      getNextPageParam: (lastPage) => (lastPage.last_page ? null : lastPage.next_cursor),
    });
  const questions = data
    ? data.pages.flatMap((page) => {
        const data = page.data;

        return data;
      })
    : [];

  console.log(error);
  useEffect(() => {
    if (order === "answers_count") {
      const limit =
        period === "today" ? 4 : period === "week" ? 8 : period === "month" ? 13 : period === "year" ? 17 : 0;
      setStop(limit);
    }
  }, [order, period]);
  const usersQuestionsFilter = () => {
    if (order === "answers_count" && stop <= questions.length) {
      return questions.slice(0, stop);
    }
    return questions;
  };

  useEffect(() => {
    const article = articleRef.current;
    const scrollContainer = xLarge || xXLarge ? document.documentElement : article;
    const element = xLarge || xXLarge ? window : article;
    setEventTarget({
      scrollContainer: scrollContainer,
      element: element,
    });
  }, [xLarge, xXLarge, articleRef]);

  useEffect(() => {
    if (eventTarget.scrollContainer && eventTarget.element) {
      const handleScroll = throttle(() => {
        const { scrollTop, clientHeight, scrollHeight } = eventTarget.scrollContainer;
        const shouldFetchMore = order !== "answers_count" || questions.length < stop;
        if (scrollTop + clientHeight >= scrollHeight - 20 && hasNextPage && !isFetchingNextPage && shouldFetchMore) {
          fetchNextPage();
          console.log(eventTarget);
        }
      }, 400);

      eventTarget.element.addEventListener("scroll", handleScroll);

      return () => {
        eventTarget.element.removeEventListener("scroll", handleScroll);
      };
    }
  }, [fetchNextPage, hasNextPage, eventTarget, isFetchingNextPage, questions.length, stop, order]);

  return (
    <>
      {isLoading && <LoadingPage />}
      <article ref={articleRef} className={`d-flex flex-column align-items-center gap-16 full-w`}>
        <div className="content">
          <OrderBy />

          <QuestionsMap questions={usersQuestionsFilter()} />
          {isSelectedQuestion && <SelectedQuestion />}
        </div>
        <span>{isFetchingNextPage ? "loading..." : !hasNextPage ? "last page or maybe know one asked" : ""}</span>
      </article>
    </>
  );
}
